import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { getFormattedAmountUI } from '@axo/shared/util/formatters';

export const unspecifiedDebtFieldOptions = {
  registerOptions: {
    shouldUnregister: true,
    deps: 'LoanApplication/AppliedAmount',
    required: 'Debt.Unspecified.error.required',
    min: {
      value: 0,
      message: 'Debt.Unspecified.error.amount',
    },
    validate: (value, form) => {
      const amount = Number(value);
      const appliedAmount = Number(form['LoanApplication/AppliedAmount']);
      if (amount > appliedAmount) {
        return 'Debt.Unspecified.error.amount';
      }
    },
  },
} satisfies IFieldOptions;

export const getRefinanceAmountSuccessValidation = (
  loanAmountValue: number
) => ({
  message: (value: string) => {
    const valueParsed = parseInt(value);
    if (isNaN(valueParsed)) return;
    if (valueParsed < loanAmountValue) {
      const remainder = loanAmountValue - valueParsed;
      const remainderFormatted = getFormattedAmountUI(remainder);
      return `De återstående ${remainderFormatted} kan användas som du vill`;
    }
  },
});

export const unspecifiedDebtMonthlyDebtPaymentFieldOptions = {
  registerOptions: {
    shouldUnregister: true,
    deps: 'Debt/Unspecified/RefinanceAmount',
    required: 'Debt.Unspecified.MonthlyDebtPayment.error.required',
    min: {
      value: 0,
      message: 'Debt.Unspecified.MonthlyDebtPayment.error.required',
    },
  },
  warningValidation: {
    message: (value, form) => {
      const refinanceAmount = Number(
        form?.['Debt/Unspecified/RefinanceAmount']
      );
      if (!refinanceAmount) return;

      const amount = Number(value);
      if (amount > refinanceAmount) {
        return 'Debt.Unspecified.MonthlyDebtPayment.error.soft.amount';
      }
    },
  },
} satisfies IFieldOptions;
